import { z } from 'zod';

export const ACL_RUNTIME_MAX_AGE_MS = 180_000;

export const AclSourceSchema = z.enum(['manual', 'preset', 'dns', 'learned']);
export type AclSource = z.infer<typeof AclSourceSchema>;

export const AclTrunkOptionSchema = z.object({
  trunk_id: z.string().uuid(),
  tenant_id: z.string().uuid(),
  name: z.string(),
  carrier_host: z.string().nullable(),
});
export type AclTrunkOption = z.infer<typeof AclTrunkOptionSchema>;

export const AclDnsResolutionSchema = z.object({
  trunk_id: z.string().uuid(),
  host: z.string(),
  ips: z.array(z.string().ip()),
  temporary_failure: z.boolean(),
  retained_until: z.string().datetime().nullable(),
});
export type AclDnsResolution = z.infer<typeof AclDnsResolutionSchema>;

export const AclNodeConfirmationSchema = z.object({
  node: z.string(),
  status: z.enum(['applied', 'failed']),
  attempted_at: z.string().datetime(),
});
export type AclNodeConfirmation = z.infer<typeof AclNodeConfirmationSchema>;

export const AclRuntimeSnapshotSchema = z.object({
  generated_at: z.string().datetime(),
  projection_digest: z.string().nullable(),
  nodes: z.array(AclNodeConfirmationSchema),
  dns: z.array(AclDnsResolutionSchema),
});
export type AclRuntimeSnapshot = z.infer<typeof AclRuntimeSnapshotSchema>;

export const EffectiveAclRowSchema = z.object({
  id: z.number().int(),
  ip_addr: z.string(),
  mask: z.number().int(),
  source: AclSourceSchema,
  trunk_id: z.string().uuid(),
  trunk_name: z.string().nullable(),
  tenant_id: z.string().uuid().nullable(),
  tenant_name: z.string().nullable(),
  label: z.string().nullable(),
  provider_name: z.string().nullable(),
  provider_preset_id: z.string().uuid().nullable(),
  last_activity_at: z.string().nullable(),
});
export type EffectiveAclRow = z.infer<typeof EffectiveAclRowSchema>;

export const AclSourceCountsSchema = z.object({
  manual: z.number().int().nonnegative(),
  preset: z.number().int().nonnegative(),
  dns: z.number().int().nonnegative(),
  learned: z.number().int().nonnegative(),
});
export type AclSourceCounts = z.infer<typeof AclSourceCountsSchema>;

export const EffectiveAclSnapshotSchema = z.object({
  rows: z.array(EffectiveAclRowSchema),
  counts: AclSourceCountsSchema,
  // Null means no fresh confirmation for this exact DB projection.
  sync: AclRuntimeSnapshotSchema.nullable(),
  associations_complete: z.boolean(),
});
export type EffectiveAclSnapshot = z.infer<typeof EffectiveAclSnapshotSchema>;
